var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ma-2",attrs:{"align":"center"}},[_c('v-row',{attrs:{"no-gutters":""}},_vm._l((_vm.parts),function({ part, object }){return _c('v-col',{key:part},[_c('v-btn',{staticClass:"mr-1",attrs:{"href":_vm.partLink(object),"target":"_blank","color":"secondary"}},[_vm._v(_vm._s(part))])],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }